import ApiService from '../../api.service';

export const GET_INVIGILATION_REPORT = 'academic/marking/student-cheating-log-report';

const actions = {
  [GET_INVIGILATION_REPORT](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.query(GET_INVIGILATION_REPORT, payload)
        .then(({data}) => resolve(data))
        .catch(({response}) => reject(response));
    });
  }
};

export default {
  state: {},
  getters: {},
  mutations: {},
  actions
};
